import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import authAtom, { isAuthInitializedAtom } from '../features/auth/authAtom';
import { Spin } from 'antd';
import { ReactElement } from 'react';

const HomeRedirect = (): ReactElement => {
  const session = useAtomValue(authAtom);
  const initialized = useAtomValue(isAuthInitializedAtom);
  if (!initialized) return <Spin />;
  const target = session ? '/user' : '/login';
  return <Navigate to={target} replace />;
};

export default HomeRedirect;
